import { useConfigStore } from '~/store/config';

/**
 * This is to replace the old accessor in components that still use Options API
 * Example, before:
 * const { config } = this.$accessor;
 * return config.home_url;
 *
 * After:
 * return this.$accessor('config', 'home_url');
 */

export default defineNuxtPlugin(() => {
  return {
    provide: {
      accessor: (store: 'config' | 'cart', value: string, value2: string | null = null) => {

        if (store === 'config') {
          const config = useConfigStore();
          //@ts-ignore
          if (value2 && config[value] && config[value][value2]) {
            //@ts-ignore
            return config[value][value2];
            //@ts-ignore
          } else if (config[value]) {
            //@ts-ignore
            return config[value];
          } else {
            console.warn(value + ' does not exist in store config');
          }
        }
        return '';
      },
    },
  };

});
